import React, { useEffect, useState } from 'react';
import { Card, CardMedia, Button, Typography, Box } from '@mui/material';
import { styled } from '@mui/system';
import { useNavigate } from 'react-router-dom';

const CustomCard = styled(Card)(({ theme }) => ({
  width: 250,
  height: 380,
  margin: 'auto',
  marginTop: '25px',
  borderRadius: 20,
  overflow: 'hidden',
  position: 'relative',
  boxShadow: '0 8px 24px rgba(0,0,0,0.6)',
}));

const OverlayContent = styled(Box)(({ theme }) => ({
  position: 'absolute',
  bottom: 0,
  width: 225,
  background: 'linear-gradient(to top, rgba(0,0,0,0.9), rgba(0,0,0,0.4))',
  color: '#fff',
  padding: theme.spacing(2),
  zIndex: 2,
}));

const StyledButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(1),
  width: '100%',
  backgroundColor: '#ff3c3c',
  color: '#fff',
  fontWeight: 600,
  borderRadius: 16,
  padding: '10px',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: '#e63333',
  },
}));

const MovieAppCard = ({ movieId, userId, setMovieId, config }) => {
  const [movieData, setMovieData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchMovieData = async () => {
      try {
        const response = await fetch('https://payvideos.com.br/backend/get-movie-miniapp', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ userId, movieId, bot: config.owner, config }),
        });

        const data = await response.json();
        console.log("data", data)
        setMovieData(data); // Supondo que data contenha { name, image, etc. }

      } catch (error) {
        console.error('Erro ao buscar dados do filme:', error);
      }
    };

    if (userId && movieId) {
      fetchMovieData();
    }
  }, [userId, movieId]);

  function handleOptionClick(link) {
    window.open(link, '_blank');
    setMovieId(null)
  }

  if (!movieData) return null;
  return (
    <CustomCard>
      <CardMedia
        component="img"
        image={`https://curtaflix.payvideos.com.br/telegram/images/${movieData.image}`}
        alt={movieData.name}
        sx={{
          height: '100%',
          width: '100%',
          objectFit: 'cover',
        }}
      />
      <OverlayContent>
        <Typography variant="subtitle1" fontWeight="bold" textAlign={'center'}>
          {movieData.name}
        </Typography>
        <Typography variant="body2" sx={{ mt: 0.5 }}>
          {movieData.button.message}
        </Typography>
        {movieData.button.options.map((item,i) => <StyledButton key={i} onClick={() => handleOptionClick(item.link)}>
          {item.text}
        </StyledButton>)}
      </OverlayContent>
    </CustomCard>
  );
};

export default MovieAppCard;
